import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CONTACT_INFO_DETAILS_STATUS } from '../../../consts/enums';
import { Download } from '../../../icons/download';
import STRING_KEYS from '../../../language/keys';
import { ContactInfoLoadState } from './ContactInfoLoadState';
import { style } from './style';

type ContactDetailsHeaderProps = {
  status: ContactInfoStatus | '',
  errorMessage: string,
  onRequestMissingContactDetailsClick: () => void,
  showGetMissingContactDetails?: boolean,
  isDisabled: boolean,
}

export const ContactDetailsHeader = ({
  status,
  errorMessage,
  onRequestMissingContactDetailsClick,
  showGetMissingContactDetails,
  isDisabled,
}:ContactDetailsHeaderProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const renderButton = () => {
    if (status === '' ||
      status === CONTACT_INFO_DETAILS_STATUS.FAILED
    ) {
      return (
        <Button
          variant="text"
          sx={ style.buttonDefault.sx }
          startIcon={ <Download /> }
          onClick={ onRequestMissingContactDetailsClick }
          disabled={ isDisabled }
        >
          {translate(STRING_KEYS.GET_CONTACT_INFO)}
        </Button>
      );
    }

    return null;
  };
  
  return (
    <Box sx={ style.Box.sx }>
      <Box style={ { padding: '24px 24px' } }>
        <Typography
          variant="h6"
          sx={ style.title.sx }
          style={ style.title.Typographyh6 }
        >
          {translate(STRING_KEYS.CONTACT_INFO)}
        </Typography>
        <Typography variant="body2" sx={ style.subtitle.sx }>
          {translate(STRING_KEYS.UPDATE_CONTACT_INFO_INFORMATION)}
        </Typography>
      </Box>
      {showGetMissingContactDetails && (
        <Box sx={ style.BoxStatus.sx }>
          <Box sx={ style.button.sx }>
            {renderButton() }
          </Box>
          <Box>
            <ContactInfoLoadState
              status={ status }
              errorMessage={ errorMessage }
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

ContactDetailsHeader.defaultProps = {
  showGetMissingContactDetails: false,
};
